<template>
    <div class="">
        <div class="row " v-if="activity_log">
            <div class="col-md-6">
                <div class="card punch-status" >
                    <div class="card-body p-2" >
                        <h5 class="card-title">Timesheet <small class="text-muted">{{this.attendance_date}}</small></h5>
                        <!-- <h5 class="card-title">Timesheet <small class="text-muted"></small></h5> -->
                        <div class="punch-det">
                            <h6>Punch In at</h6>
                            <p>{{formatMe(check_in)}}</p>
                        </div>
                        <div class="punch-info">
                            <div class="punch-hours">
                                <span>{{convertMinsToHrsMins(work_time_by_adding_cur_time_dif)}} hrs</span>
                            </div>
                        </div>
                        <div class="punch-det">
                            <h6>Punch Out at</h6>
                            <p>{{formatMe(checkout)}}</p>
                        </div>
                        <div class="statistics">
                            <div class="row">
                                <div class="col-md-6 col-6 text-center">
                                    <div class="stats-box">
                                        <p>Break</p>
                                        <h6>{{convertMinsToHrsMins(break_time)}} hrs</h6>
                                    </div>
                                </div>
                                <!-- commented out by faroque -->
                                <!--<div class="col-md-12 col-12 text-center">
                                    <div class="stats-box">
                                        <p>Overtime</p>
                                        <h6>{{over_time}} hrs</h6>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-else>
                    <h5 class="card-title">No Activity Found For: <small class="text-muted">{{this.attendance_date}}</small></h5>
                </div> -->
            </div>
            <div class="col-md-6">
                <div class="card recent-activity">
                    <div class="card-body pl-3">
                        <h5 class="card-title">Activity</h5>
                        <ul class="res-activity-list">
                            <li  v-for="(activity, index) in activity_log.split(',')">
                                <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                <p class="mb-0" v-else>Punch Out at</p>
                                <p class="res-activity-time">
                                    <i class="far fa-clock"></i>
                                    {{formatMe(activity) }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            No Activity Found.
        </div>
    
    </div>
</template>
<script> 
  
    import moment from 'moment';
    export default{
        props: [ 'moment','attendance_date'],
        components: {
        },
        data(){
            const now = new Date(); 
            return {
                check_in : null, 
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,
                work_time_by_adding_cur_time_dif : 0,
               
            }
        },
        methods:{
            
            getAttendanceActivity : function(ins)
            {
                console.log(this.attendance_date);
                let today = moment().format('YYYY-MM-DD');
                if(this.attendance_date=='' && this.attendance_date == undefined)
                {
                    this.attendance_date = today;
                }
                axios.get(this.$api_url+'/front/employee/attendance/activity/datewise' , {
                    params: {
                        attendance_date:this.attendance_date,
                    }
                }).then(function(response){
                    console.log(response);
                    if(response.data.length != 0)
                    {
                        this.check_in = response.data.check_in;
                        this.checkout = response.data.checkout;
                        this.break_time = response.data.break_time;
                        this.work_time = response.data.work_time;
                        this.activity_log = response.data.activity_log;
                        this.work_time_by_adding_cur_time_dif = response.data.work_time_by_adding_cur_time_dif;
                        console.log(this.check_in);

                        
                    }     
                }.bind(this));
            },
            convertMinsToHrsMins: function (minutes) {
                var h = Math.floor(minutes / 60);
                var m = minutes % 60;
                h = h < 10 ? '0' + h : h;
                m = m < 10 ? '0' + m : m;
                return h + ':' + m;
            },
            formatMe :function(minutes){
                if(minutes!== "00:00:00" || minutes == "00:00")
                {
                    return moment(minutes, "hh:mm").format('LT');
                }
                else 
                {
                    minutes = "N/R";
                    
                }
            },
           
            
            
        },
        created: function(){
            // this.showActivity();
             this.attendances_date = moment().format('YYYY-MM-DD');
             this.getAttendanceActivity();
         
        },
        mounted() {
            var dataL = this.$root.$on('message_from_p_i_o',(1) );   
            console.log(dataL);
        },
 
    }

</script>